module.exports = __webpack_public_path__ + "img/cluster.4db80445.svg";